module.exports = __webpack_public_path__ + "img/wholesale4.4254a2ab.png";